/* eslint-disable no-param-reassign */

import Vue from 'vue';

import arrowIcon from '@/helpers/arrowIcon';

function makeDeviceIcon(active, device) {
  return L.divIcon({
    iconSize: [20, 20],
    className: `device-marker${active ? '' : ' device-marker-inactive'}`,
    html: `
      ${arrowIcon(device.color)}
      <div class="device-name">${device.display_name}</div>
    `,
  });
}

export default {
  namespaced: true,

  state: {
    devices: [],
  },

  getters: {
    enabled: state => state.devices.filter(d => d.enable),
    notHidden: state => state.devices.filter(d => d.enable && d.show),
    devicesWithLabels: state => state.devices.filter(d => d.show && d.location && d.location.labelIcon && d.location.age === 'good'),
    devicesWithLocation: state => state.devices.filter(d => d.show && d.location && d.location.age !== 'timeout'),
    devicesWithHistory: state => state.devices.filter(d => d.show && !!d.history && d.location && d.location.age === 'good'),
    trackedCoords: (state) => {
      const device = state.devices.find(d => d.track);

      if (device && device.location) {
        return device.location.latlng;
      }

      return L.latLng(46.5475, 6.6422);
    },
  },

  mutations: {
    setDevices(state, data) {
      data.devices.forEach((d) => {
        const device = state.devices.find(dev => dev.id === d.id);

        if (d.show === undefined) {
          Vue.set(d, 'show', true);
        }

        if (d.location) {
          d.location.lastSeen = new Date(d.location.timestamp);
          d.location.locationIcon = makeDeviceIcon(true, d);
          d.location.latlng = L.latLng(d.location.latitude, d.location.longitude);

          const delay = Date.now() - d.location.lastSeen;

          d.age = 'timeout';

          if (delay < Vue.prototype.$config.map.deviceLagDelay) {
            d.age = 'good';
          } else if (delay < Vue.prototype.$config.map.deviceTimeoutDelay) {
            d.age = 'lag';
          }
        }

        if (d.status) {
          d.battery = d.status.battery;
        }

        if (device) {
          Object.assign(device, d);
        } else {
          state.devices.push(d);
        }
      });
    },

    updateDevice(state, data) {
      const deviceIndex = state.devices.findIndex(d => d.id === data.device.id);

      if (deviceIndex === -1) {
        state.devices.push(data.device);
      } else {
        state.devices[deviceIndex] = data.device;
      }
    },

    trackDevice(state, data) {
      const device = state.devices.find(d => d.id === data.id);
      Vue.set(device, 'track', data.track);
    },
  },

  actions: {
    fetchList(ctx, data) {
      if (!data || !data.tenantId) {
        throw new Error('No tenant selected!');
      }

      const prefs = this.getters['preferences/preferences'];

      return Vue.prototype.$api.get(`/tenants/${data.tenantId}/devices`)
        .then((res) => {
          const hideIds = prefs.hideDeviceIDs || [];
          const devices = (res.data || []).map((d) => {
            d.show = !hideIds.includes(d.id);
            return d;
          });

          ctx.commit('setDevices', { devices });
        });
    },

    clearTrack(ctx) {
      ctx.state.devices.forEach((device) => {
        ctx.commit('trackDevice', {
          id: device.id,
          track: false,
        });
      });
    },
  },
};
